import React from "react";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import checkVerifiedIcon from "@src/assets/svg/check-badge.svg";
import styles from "./blueprint-table-body-flex-wrapper-with-verified-icon.module.scss";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { useI18N } from "@src/language/language-context";

const cssClassName = "blueprint-table-body-flex-wrapper-with-verified-icon";

interface BlueprintTableBodyFlexWrapperWithVerifiedIconPropTypes {
  blueprint: BlueprintsArrayObjectTypes;
}

export const BlueprintTableBodyFlexWrapperWithVerifiedIcon = ({
  blueprint,
}: BlueprintTableBodyFlexWrapperWithVerifiedIconPropTypes) => {
  const i18n = useI18N();

  const texts = {
    verifiedIconAltText: i18n(
      "modules.blueprintTableBodyFlexWrapperWithVerifiedIcon.verifiedIconAltText",
    ),
  };
  return (
    <FlexRowContainer horizontalGap={4}>
      <span className={styles[`${cssClassName}__text`]}>
        {blueprint.organization}
      </span>
      {blueprint.verified && (
        <img src={checkVerifiedIcon} alt={texts.verifiedIconAltText} />
      )}
    </FlexRowContainer>
  );
};
